/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Force_UnlockInputs */



/**
* | output |
* | --- |
* | "Force Unlock" |
*
* @param {Offline_Force_UnlockInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const offline_force_unlock = /** @type {((inputs?: Offline_Force_UnlockInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Force_UnlockInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Forcer le déverrouillage")
	if (locale === "es") return /** @type {LocalizedString} */ ("Forzar desbloqueo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Forçar desbloqueio")
	if (locale === "it") return /** @type {LocalizedString} */ ("Forza sblocco")
	return /** @type {LocalizedString} */ ("Force Unlock")
});